import React, { useEffect, useState } from "react";
import { pdf, Document, Page, Text, View, Image } from "@react-pdf/renderer";
import moment from "moment";
import { useLocation } from "react-router-dom";

import glock from "../Assets/glock.png";
import phone from "../Assets/telephone.png";
import whatsapp from "../Assets/whatsapp.png";
import email from "../Assets/mail.png";
import location from "../Assets/location.png";

const styles = {
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: "Helvetica",
    paddingBottom: 80,
  },
  content: { marginBottom: 0 },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logocontainer: {
    width: "100%",
    backgroundColor: "gray",
    borderRadius: "15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logo: {
    width: 250,
  },
  headerbox: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    marginVertical: 8,
  },
  headerRightbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "38%",
    border: "1px solid grey",
    borderRadius: "10px",
    gap: 3,
  },
  headerleftbox: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
    width: "60%",
    border: "1px solid grey",
    borderRadius: "10px",
    gap: 4,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: "1px solid #ccc",
    padding: 4,
  },
  col1: { width: "15%", fontSize: 8, padding: 4, textAlign: "center" },
  col2: { width: "25%", fontSize: 8, padding: 4, textAlign: "center" },
  col3: { width: "50%", fontSize: 8, padding: 4, textAlign: "left" },
  col4: { width: "25%", fontSize: 8, padding: 4, textAlign: "center" },
  col5: { width: "25%", fontSize: 8, padding: 4, textAlign: "center" },
  col6: { width: "25%", fontSize: 8, padding: 4, textAlign: "center" },

  footer: {
    position: "absolute",
    bottom: 30,
    left: 40,
    right: 40,
    paddingTop: 10,
    borderTop: "1px solid #000",
    textAlign: "center",
  },
  contactRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
  contactItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  contactText: {
    fontSize: 8,
    fontWeight: "500",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 10,
    bottom: 15,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  addressRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 4,
  },
};

const PageNumber = () => (
  <Text
    style={styles.pageNumber}
    render={({ pageNumber, totalPages }) =>
      `Page ${pageNumber} of ${totalPages}`
    }
    fixed
  />
);

const Watermark = () => (
  <Text
    style={{
      position: "absolute",
      top: "200%",
      left: "50%",
      alignItems: "center",
      textAlign: "center",
      justifyContent: "center",
      transform: "translate(-50%, -50%) rotate(-30deg)",
      opacity: 0.2,
      fontSize: 50,
      fontWeight: "bold",
      color: "#cccccc",
    }}
    fixed
  >
    Glock Auto Spare Parts
  </Text>
);

const TableHeader = () => (
  <View
    style={[
      styles.tableRow,
      { backgroundColor: "#f0f0f0", fontWeight: "bold" },
    ]}
    fixed
  >
    <Text style={styles.col1}>Date</Text>
    <Text style={styles.col2}>Transaction</Text>
    <Text style={styles.col3}>Details</Text>
    <Text style={styles.col4}>Debit</Text>
    <Text style={styles.col5}>Credit</Text>
    <Text style={styles.col6}>Balance</Text>
  </View>
);
const Tablefooter = ({ totals }) => (
  <View
    style={[
      styles.tableRow,
      { backgroundColor: "#f0f0f0", fontWeight: "bold" },
    ]}
  >
    <Text style={styles.col1}></Text>
    <Text style={styles.col2}></Text>
    <Text style={styles.col3}>Total</Text>
    <Text style={styles.col4}>{totals.totalDebit}</Text>
    <Text style={styles.col5}>{totals.totalCredit}</Text>
    <Text style={styles.col6}>{totals.finalBalance}</Text>
  </View>
);

const InvoiceDocument = ({ order, items, totals }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.logocontainer}>
        <Image src={glock} style={styles.logo} />
      </View>
      <View>
        <Text
          style={{
            padding: 12,
            fontWeight: "bold",
            fontSize: 18,
            textAlign: "center",
          }}
        >
          Customer Ledger
        </Text>
      </View>
      <View style={styles.headerbox}>
        <View style={styles.headerleftbox}>
          <Watermark />

          <Text style={{ fontWeight: "bold", fontSize: 12 }}>
            {order.customer_company_name}
          </Text>
          <Text style={{ fontSize: 10 }}>{order.customer_address}</Text>
          <Text style={{ fontSize: 10 }}>
            JAFZA, Dubai, UAE. P.O.Box - 7211
          </Text>
          <Text style={{ fontSize: 10 }}>example@gmail.com</Text>
          <Text style={{ fontSize: 10, marginTop: 20, marginBottom: 10 }}>
            TRN: {order.trn}
          </Text>
        </View>

        <View style={styles.headerRightbox}>
          <Text style={{ fontWeight: "bold", fontSize: 12 }}>
            Statement of Accounts
          </Text>

          <Text>DATE: {moment(order.delivery_date).format("DD-MM-YYYY")}</Text>
          <Text>Terms: {order.terms}</Text>
          <Text>REF NO: {order.reference_no}</Text>
        </View>
      </View>
      <View style={styles.content}>
        {/* Table */}
        <TableHeader />
        {items.map((item, index) => {
          const totalExcl = item.invoice_price * item.invoice_quantity;
          const vat = totalExcl * (item.vat_percentage / 100);
          const totalIncl = totalExcl + vat;
          return (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.col1}>{item.invDate}</Text>
              <Text style={styles.col2}>{item.transaction}</Text>
              <Text style={styles.col3}>{item.narration}</Text>
              <Text style={styles.col4}>{item.debit}</Text>
              <Text style={styles.col5}>{item.credit}</Text>
              <Text style={styles.col6}>{item.balance}</Text>
            </View>
          );
        })}
      </View>
      <Tablefooter totals={totals} />
      {/* Footer */}
      <View style={styles.footer} fixed>
        <View style={styles.contactRow}>
          <View style={styles.contactItem}>
            <Image
              src={phone}
              style={{ marginRight: 4, height: 10, width: 10 }}
            />
            <Text style={styles.contactText}>+971 4 2365733</Text>
          </View>
          <View style={styles.contactItem}>
            <Image
              src={whatsapp}
              style={{ marginRight: 4, height: 10, width: 10 }}
            />
            <Text style={styles.contactText}>+971 54 5857698</Text>
          </View>
          <View style={styles.contactItem}>
            <Image
              src={email}
              style={{ marginRight: 4, height: 10, width: 10 }}
            />
            <Text style={styles.contactText}>sajidsaeed2026@gmail.com</Text>
          </View>
        </View>
        <View style={styles.addressRow}>
          <Image
            src={location}
            style={{ marginRight: 4, height: 10, width: 10 }}
          />
          <Text style={styles.contactText}>
            Naif Arcade, Shop No.2, Street No 125, Al Nakheel Street, Near Deira
            Park Hotel, Deira, Dubai, U.A.E
          </Text>
        </View>
      </View>
      <PageNumber />
    </Page>
  </Document>
);

const CustomerInvoiceGenerator = () => {
  const location = useLocation();
  const { customer, ledger, adjustedBalance } = location.state || {};

  const order = {
    id: customer?.id,
    customer_company_name: customer?.company_name || "N/A",
    customer_address: customer?.address || "N/A",
    trn: customer?.trn || "N/A",
    delivery_date: new Date(),
    terms: customer?.terms || "Credit 30 Days",
    reference_no: customer?.reference_no || "N/A",
  };

  const items = ledger?.map((entry) => ({
    invDate: moment(entry.date).format("DD-MMM-YY"),
    transaction: entry.reference_no || entry.type,
    narration: entry.note || "-",
    debit:
      entry.type === "ORDER" &&
      ["readytodeliver", "dispatched", "deliveredorders"].includes(entry.status)
        ? entry.vat_amount
        : "",
    credit: entry.type === "TRANSACTION" ? entry.amount : "",
    balance: parseFloat(entry.balance || 0).toFixed(2),
  }));

  // 🔹 Totals
  const totalDebit = (ledger || []).reduce((acc, entry) => {
    if (
      entry.type === "ORDER" &&
      ["readytodeliver", "dispatched", "deliveredorders"].includes(entry.status)
    ) {
      return acc + parseFloat(entry.vat_amount || 0);
    }
    return acc;
  }, 0);

  const totalCredit = (ledger || []).reduce((acc, entry) => {
    return entry.type === "TRANSACTION"
      ? acc + parseFloat(entry.amount || 0)
      : acc;
  }, 0);

  const finalBalance = totalDebit - totalCredit;

  const totals = {
    totalDebit: totalDebit.toFixed(2),
    totalCredit: totalCredit.toFixed(2),
    finalBalance: finalBalance.toFixed(2),
    adjustedBalance: adjustedBalance || "0.00",
  };

  useEffect(() => {
    const generatePDF = async () => {
      try {
        const blob = await pdf(
          <InvoiceDocument order={order} items={items} totals={totals} />
        ).toBlob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      } catch (error) {
        console.error("PDF generation failed:", error);
      }
    };
    generatePDF();
  }, []); // ✅ Consider adding dependencies if needed

  return (
    <div className="p-6 text-center">
      <h2 className="text-lg font-semibold">Generating PDF...</h2>
      <p>Please wait while your PDF opens in a new tab.</p>
    </div>
  );
};

export default CustomerInvoiceGenerator;
